import getClosest from '../utilities/get-closest'
import forEach from '../utilities/_forEach'

const primaryNav = {
	root: null,
	popupTriggers: null,
	activeElement: null,

	timer: null,
	className: 'is-expanded',

	isInMobileState() {
		return this.burger.offsetParent !== null
	},

	getId(element) {
		return element.getAttribute('data-popup-trigger')
	},

	getSubmenuMinHeight(submenu) {
		const submenuDefaultMinHeight = 236
		const navPanels = submenu.querySelectorAll('[data-nav-panel]')

		if (!navPanels) return submenuDefaultMinHeight

		const containerMargins = 32

		// Start with the margins between each box
		let submenuMinHeight = (navPanels.length - 1) * containerMargins

		// Then add the height of each panel
		submenuMinHeight += Object.keys(navPanels).reduce((height, index) => {
			const panelItem = navPanels[index]
			height += panelItem.getBoundingClientRect().height
			return height
		}, 0)

		// And, finally, add the vertical padding from the sub-menu, because it's a border-box, not content-box
		const computedStyle = window.getComputedStyle(submenu)
		const padding = parseInt(computedStyle.getPropertyValue('padding-top')) * 2 // + parseInt(computedStyle.getPropertyValue('padding-top'))

		submenuMinHeight += padding

		return submenuMinHeight
	},

	sizePanel() {
		if (!this.activeElement) return

		const submenu = this.activeElement.querySelector('.sub-menu')
		if (!submenu) return

		const contents = this.activeElement.querySelectorAll('[data-nav-panel-content]')
		if (!contents) return

		const submenuMinHeight = this.getSubmenuMinHeight(submenu)

		let tallestPanel = 0
		// const containerPadding = 32 * 2 // Top/Bottom padding in a sub-menu
		const containerPadding = 75 // Top/Bottom padding in a sub-menu 2.7rem + 2rem = 75.2px
		// const columnVerticalOffset = 16 * 2 // bottom padding
		const columnVerticalOffset = 16 // bottom padding

		Object.keys(contents).forEach((index) => {
			const content = contents[index]
			content.classList.add('is-measuring')

			tallestPanel = Math.max(tallestPanel, content.getBoundingClientRect().height)
			content.classList.remove('is-measuring')
		})

		const panelHeight = tallestPanel + containerPadding + columnVerticalOffset
		const maxPanelHeight = window.innerHeight - this.masthead.getBoundingClientRect().height - containerPadding
		const minPanelHeight = Math.max(
			submenuMinHeight, // Don't allow a panel with 1 or 2 links to collapse into itself
			//Math.min(maxPanelHeight, panelHeight)
			Math.min(maxPanelHeight, panelHeight)
		)

		// const pushHeight = window.innerHeight - this.getShellHeight()
		const pushHeight = tallestPanel

		// We need to set some min and max panel heights
		// The min panel height is the tallest panel among the group so that, as each panel is toggled into view, the entire enclosure doesn't
		// bounce up and down

		// The max height needs to limit the height to the masthead + viewport height. Any overflow beyond that must be scrollable
		submenu.style.setProperty('--min-panel-height', `${minPanelHeight}px`)
		submenu.style.setProperty('--max-panel-height', `${maxPanelHeight}px`)
		submenu.style.setProperty('--push-height', `${Math.min(pushHeight, minPanelHeight)}px`)
	},

	expand(element) {
		// document.body.style.overflow = 'hidden'

		var elementId = this.getId(element)

		if (this.activeElement) {
			this.activeElement.classList.remove(this.className)
			this.activeElement.querySelector('button').setAttribute('aria-expanded', false)

			if (elementId === this.getId(this.activeElement)) {
				clearTimeout(this.timer)
				this.activeElement = null
			}
		}

		this.activeElement = element
		this.activeElement.classList.add(this.className)
		this.activeElement.querySelector('button').setAttribute('aria-expanded', true)

		const closeOnClick = (e) => {
			const primaryNav = getClosest(e.target, '.primary-nav')
			if (!primaryNav) {
				this.collapse(element, true)
			}
			document.removeEventListener('click', closeOnClick.bind(this))
		}

		document.addEventListener('click', closeOnClick.bind(this), true)

		window.addEventListener('keydown', this.collapseOnEsc)

		this.sizePanel()
	},

	collapse(element, force = false) {
		// document.body.style.overflow = 'visible'

		const delay = force ? 0 : 500

		this.timer = setTimeout(() => {
			if (element !== null) {
				element.classList.remove(this.className)
				element.querySelector('button').setAttribute('aria-expanded', false)

				this.activeElement = null

				const active = element.querySelectorAll('.is-expanded')
				if (active) {
					Array.from(active).forEach((item) => item.classList.remove('is-expanded'))
				}

				const defaultActive = element.querySelector('[data-default-panel]')
				if (defaultActive) {
					defaultActive.classList.add('is-expanded')
					const content = defaultActive.querySelector('.nav-panel__content')
					if (content) {
						content.classList.add('is-expanded')
					}
				}
			}
		}, delay)
	},

	collapseOnEsc(e) {
		if (e.key === 'Escape') {
			if (this.activeElement) {
				this.collapse(this.activeElement, true)
			}

			window.removeEventListener('keydown', this.collapseOnEsc)
		}
	},

	getShellHeight() {
		const mastheadHeight = this.masthead.getBoundingClientRect().height

		const wpAdminBar = document.getElementById('wpadminbar')
		const adminbarHeight = wpAdminBar ? wpAdminBar.getBoundingClientRect().height : 0

		const aimmsSupportMenu = document.querySelector('.aimms-support-menu')
		const aimmsSupportMenuHeight = aimmsSupportMenu ? aimmsSupportMenu.getBoundingClientRect().height : 0

		// const alertBanner = document.querySelector('[data-alert-banner]')
		// const alertBannerHeight = alertBanner ? alertBanner.getBoundingClientRect().height : 0

		// console.log({ mastheadHeight, adminbarHeight, aimmsSupportMenuHeight, alertBannerHeight })
		// return mastheadHeight + adminbarHeight + aimmsSupportMenuHeight + alertBannerHeight

		return mastheadHeight + adminbarHeight + aimmsSupportMenuHeight
	},

	cacheDom() {
		this.masthead = document.querySelector('[data-masthead]')
		this.mastheadRoot = this.masthead.querySelector('.masthead__root')
		this.root = document.querySelector('.js-primary-nav')
		this.popupTriggers = this.root.querySelectorAll('[aria-haspopup]')
		this.burger = document.querySelector('.js-burger')
		this.closeX = document.querySelectorAll('.js-primary-nav-close')
	},

	bind() {
		this.popupTriggers.forEach((element, index) => {
			element.setAttribute('data-popup-trigger', index)
			const parentNode = element.parentNode

			element.addEventListener(
				'keydown',
				(e) => {
					if (e.keyCode === 13) {
						e.preventDefault()
						parentNode.classList.contains(this.className) ? this.collapse(e.target.parentNode, true) : this.expand(e.target.parentNode)
					}
				},
				true
			)

			element.addEventListener(
				'click',
				(e) => {
					e.preventDefault()
					parentNode.classList.contains(this.className) ? this.collapse(e.target.parentNode, true) : this.expand(e.target.parentNode)
				},
				true
			)
		})

		forEach(this.closeX, (element) => {
			element.addEventListener('click', () => {
				this.collapse(this.activeElement, true)
			})
		})

		window.addEventListener('resize', this.sizePanel.bind(this))
	},

	init() {
		this.cacheDom()
		this.bind()

		this.collapseOnEsc = this.collapseOnEsc.bind(this)
	},
}

export default primaryNav
